module.exports = __webpack_public_path__ + "static/media/oracle.f6b5a688.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/oracle.png
// module id = 1314
// module chunks = 49